import { standaloneUrl } from '../embed';
import { useStrings } from '../i18n/context';

/** Shown only in a frame (the P2 iframe embed): phones get the full screen in a tab of its own. */
export function OpenInNewTab() {
  const strings = useStrings();
  return (
    <a className="button open-in-new-tab" href={standaloneUrl(window.location.href)} target="_blank" rel="noopener noreferrer">
      {strings.openInNewTab}
    </a>
  );
}
